"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useLatest_1 = __importDefault(require("./useLatest"));
function useInterval(handler, intervalMs) {
    const handlerRef = (0, useLatest_1.default)(handler);
    (0, react_1.useEffect)(() => {
        const intervalId = setInterval(() => {
            handlerRef.current();
        }, intervalMs);
        return () => {
            clearInterval(intervalId);
        };
    }, [intervalMs]);
}
exports.default = useInterval;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlSW50ZXJ2YWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2hvb2tzL3VzZUludGVydmFsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsaUNBQWtDO0FBQ2xDLDREQUFvQztBQUlwQyxTQUF3QixXQUFXLENBQ2pDLE9BQTZCLEVBQzdCLFVBQWtCO0lBRWxCLE1BQU0sVUFBVSxHQUFHLElBQUEsbUJBQVMsRUFBQyxPQUFPLENBQUMsQ0FBQztJQUV0QyxJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ2IsTUFBTSxVQUFVLEdBQUcsV0FBVyxDQUFDLEdBQUcsRUFBRTtZQUNsQyxVQUFVLENBQUMsT0FBTyxFQUFFLENBQUM7UUFDdkIsQ0FBQyxFQUFFLFVBQVUsQ0FBQyxDQUFDO1FBRWYsT0FBTyxHQUFHLEVBQUU7WUFDVixhQUFhLENBQUMsVUFBVSxDQUFDLENBQUM7UUFDNUIsQ0FBQyxDQUFDO0lBQ0osQ0FBQyxFQUFFLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQztBQUNuQixDQUFDO0FBZkQsOEJBZUMifQ==